<template>
  <div class="position-relative" v-if="isLoaded">
    <HeaderBackground :backgroundPath="`/${$staticPath}/${index.background}`"></HeaderBackground>
    <div class="gotoTop" :class="{active: cursorActive}" @click.prevent="gotoTop">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </div>
    <div class="content">
      <Header :headerText="index.headerText"></Header>
      <Catagory :catagory="catagory.catagory" @scrollTo="scrollTo" ref="catagory"></Catagory>
      <Schedule :schedule="schedule.schedule" ref="schedule"></Schedule>
      <Life :life="life" ref="life"></Life>
      <Activities :activities="activities" ref="activities"></Activities>
      <Info :info="info" ref="info"></Info>
      <Social :social="social" ref="social"></Social>
      <Handbook :handbook="handbook" ref="handbook"></Handbook>
    </div>
  </div>
</template>

<script>
import { throttle } from 'throttle-debounce'
import HeaderBackground from '../COMMON/HeaderBackground.vue'
import Header from '../COMMON/Header.vue'
import Catagory from './Catagory.vue'
import Schedule from './Schedule.vue'
import Life from './Life.vue'
import Activities from './Activities.vue'
import Info from './Info.vue'
import Social from './Social.vue'
import Handbook from './Handbook.vue'

export default {
  components: {
    HeaderBackground,
    Header,
    Catagory,
    Schedule,
    Life,
    Activities,
    Info,
    Social,
    Handbook
  },
  data () {
    return {
      cursorActive: false,
      index: {},
      catagory: {},
      schedule: {},
      life: {},
      activities: {},
      social: {},
      handbook: {},
      isLoaded: false
    }
  },
  created () {
    this.init()
    window.addEventListener('scroll', throttle(100, this.onMoving), true)
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var index = await import('../../json/en/student/index.json')
        var catagory = await import('../../json/en/student/catagory.json')
        var schedule = await import('../../json/en/student/schedule.json')
        var life = await import('../../json/en/student/life.json')
        var activities = await import('../../json/en/student/activities.json')
        var info = await import('../../json/en/student/info.json')
        var social = await import('../../json/en/student/social.json')
        var handbook = await import('../../json/en/student/handbook.json')
      } else {
        index = await import('../../json/th/student/index.json')
        catagory = await import('../../json/th/student/catagory.json')
        schedule = await import('../../json/th/student/schedule.json')
        life = await import('../../json/th/student/life.json')
        activities = await import('../../json/th/student/activities.json')
        info = await import('../../json/th/student/info.json')
        social = await import('../../json/th/student/social.json')
        handbook = await import('../../json/th/student/handbook.json')
      }
      this.index = index
      this.catagory = catagory
      this.schedule = schedule
      this.life = life
      this.activities = activities
      this.info = info
      this.social = social
      this.handbook = handbook
      this.isLoaded = true
    },
    scrollTo: function (id) {
      window.scroll({
        top: window.pageYOffset + this.$refs[`${id}`].$el.getBoundingClientRect().top - 90,
        left: 0,
        behavior: 'smooth'
      })
      console.log(this.$refs['test'].$el.getBoundingClientRect().top)
    },
    gotoTop: function () {
      window.scroll({
        top: window.pageYOffset + this.$refs[`catagory`].$el.getBoundingClientRect().top - 120,
        left: 0,
        behavior: 'smooth'
      })
    },
    onMoving: function () {
      var position = window.scrollY
      var breakPoint = window.pageYOffset + this.$refs[`schedule`].$el.getBoundingClientRect().top - 90
      this.cursorActive = position > breakPoint
    }
  }
}
</script>

<style scoped>
  .gotoTop {
    position: fixed;
    right: 45px;
    bottom: 30px;
    padding: 10px;
    background-color: rgba(35, 35, 35, 0.6);
    z-index: -1;
    opacity: 0;
    transition: 0.35s;
  }

  .gotoTop.active {
    z-index: 15;
    opacity: 1;
    cursor: pointer;
  }

  .gotoTop i {
    color: #FFF;
  }

  .content {
    background-color: #FFF;
    padding: 60px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Index.vue